import { NotificationDetailIcon, NotificationDetailList } from './NotificationDetailList';

export default {
  list: NotificationDetailList,
  icon: NotificationDetailIcon,
};
